import React from 'react';
import SvgIcon from './svg-icon.jsx';

export default function PhotoAttachmentIcon({
  className = '',
  size = 24,
  title,
  ...props
}) {
  return (
    <SvgIcon
      name="photo-attachment"
      viewBox="0 0 20 18"
      size={size}
      className={['photo-attachment', 'compose-action-icon', className].filter(Boolean).join(' ')}
      title={title}
      {...props}
    />
  );
}
